var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ManageBase',[_c('template',{slot:"template"},[_c('Pankuzu'),_c('Title'),_c('SendUserForm',{on:{"go_back":_vm.go_back}}),_c('div',{staticClass:"notice"},[_vm._v("※携帯メールアドレスをご登録いただく場合、info@story-pla.netからのドメイン受信許可を設定してください。")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }